import {
  IconShield,
  IconTrash,
  IconRecycle,
  IconTruck,
  IconPhoneCall,
  IconKey,
  IconShieldLock,
  IconDoorExit,
  IconFlame,
  IconFirstAidKit,
  IconGauge,
  IconAlertTriangle,
  IconFileText,
  IconPlug,
  IconSwitch,
  IconBolt,
  IconTool,
  IconDroplet,
  IconArrowDownCircle,
  IconFilter,
  IconLayout,
  IconTemperature,
  IconAirConditioning,
  IconGasStation,
  IconWorld,
  IconId,
  IconWifi,
  IconRouter,
  IconSpray,
  IconPlant,
  IconPool,
  IconBallTennis,
  IconBarbell,
  IconFish,
  IconDeviceTv,
  IconDropCircle,
  IconTeapot,
  IconDeviceSpeaker,
  IconVacuumCleaner,
  IconAlertHexagon,
  IconBath,
  IconBarrel,
  IconInfoCircle,
  IconBulb,
  IconTag,
} from '@tabler/icons-react';

export const ICONS = {
  // General Information
  shield: IconShield,
  trash: IconTrash,
  recycle: IconRecycle,
  truck: IconTruck,
  'info-circle': IconInfoCircle,

  // Security and Access
  'phone-call': IconPhoneCall,
  key: IconKey,
  'shield-lock': IconShieldLock,
  'door-exit': IconDoorExit,
  flame: IconFlame,
  'first-aid-kit': IconFirstAidKit,
  gauge: IconGauge,
  'alert-triangle': IconAlertTriangle,
  'file-text': IconFileText,

  // Electricity and Lighting
  plug: IconPlug,
  switch: IconSwitch,
  bolt: IconBolt,
  tool: IconTool,
  bulb: IconBulb,

  // Water and Sanitation
  droplet: IconDroplet,
  'drop-circle': IconDropCircle,
  'arrow-down-circle': IconArrowDownCircle,
  filter: IconFilter,
  barrel: IconBarrel,
  teapot: IconTeapot,
  layout: IconLayout,

  // Heating and Air Conditioning
  radiator: IconFlame,
  temperature: IconTemperature,
  'air-conditioning': IconAirConditioning,
  'gas-station': IconGasStation,

  // Internet and Multimedia
  world: IconWorld,
  id: IconId,
  wifi: IconWifi,
  router: IconRouter,
  'device-speaker': IconDeviceSpeaker,

  // Maintenance and Storage
  spray: IconSpray,
  'vacuum-cleaner': IconVacuumCleaner,
  'alert-hexagon': IconAlertHexagon,
  plant: IconPlant,

  // Leisure and Specific Equipment
  pool: IconPool,
  bath: IconBath,
  'ball-tennis': IconBallTennis,
  barbell: IconBarbell,
  fish: IconFish,
  'device-tv': IconDeviceTv,

  // Custom
  tag: IconTag,
};

export default ICONS;
